import BlogItem from './BlogItem'
import Row from 'react-bootstrap/Row'

//passed and rendered to blog/[blog_slug].js
export default function BlogList({articles}) {
    return(
        <Row>
            {articles.map((article) => (<BlogItem key={article.id} article={article} />))}
        </Row>
    )
}